document.addEventListener('DOMContentLoaded', function () {
    const flktyConfig = {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        arrowShape: "M 30,50 L 60,80 L 66,74 L 42,50 L 66,26 L 60,20 Z"
        //arrowShape: "M 37.5 12.5 L 75 50 L 37.5 87.5"
    };

    const mainProductGallery = document.querySelector('.main-product-gallery');
    const spinner = document.querySelector('.loading__spinner');

    const flktyMainConfig = {
        ...flktyConfig,
        on: {
          ready: function() {
            console.log('Flickity is ready');
            mainProductGallery.classList.add('flickity--ready');
            //spinner.classList.add('hidden');

            const cells = mainProductGallery.querySelectorAll(".gallery-cell");

            //console.log("Cells: ", cells);

            cells.forEach(cell => {
              const img = cell.querySelector("img");
              const spinner = cell.querySelector(".loading__spinner");

              //consolse.log("Cell: ", cell);
              //console.log("Image: ", img);
              //console.log("Spinner: ", spinner);

              // Show spinner by default
              spinner.classList.remove("hidden");

              if (img.complete && img.naturalWidth !== 0) {
                // Image already loaded from cache
                spinner.classList.add("hidden");
              } else {
                img.addEventListener("load", () => {
                  spinner.classList.add("hidden");
                  console.log("Image loaded: ", img.src);
                });

                img.addEventListener("error", () => {
                  spinner.classList.add("hidden"); // hide spinner even if load fails
                  cell.classList.add("image--error");
                });
              }
            });
          },
          /*change: function( index ) {
            console.log( 'Slide changed to' + index );
          },*/
          /*select: function () {
            const selectedSlide = this.selectedElement;
            const img = selectedSlide.querySelector('img');

            if (img) {
              // Show spinner if image not loaded yet
              if (!img.complete) {
                spinner.classList.remove('hidden');

                img.addEventListener('load', function handler() {
                  spinner.classList.add('hidden');
                  img.removeEventListener('load', handler);
                });
              } else {
                spinner.classList.add('hidden'); // Image already loaded
              }
            } else {
              spinner.classList.add('hidden'); // No image in slide
            }
          },*/
        }
    };    

    const flktyMain = new Flickity(mainProductGallery, flktyMainConfig);
    //imagesLoaded('.main-product-gallery', () => {
    
    

    /*(if (flktyMain) {
      flktyMain.options.draggable = false;
      flktyMain.updateDraggable();
    }*/

    Fancybox.bind('[data-fancybox="gallery"]', {
      zoomEffect: false,
      hideClass: false,
      showClass: false,
      Hash: false,
      Carousel: {
        Dots: false,
        Navigation: false,
        dragFree: false,
        Zoomable: {
          Panzoom: {
            minScale: 1,
            maxScale: 1.5,
            clickAction: 'toggleCover',
            //dblClickAction: 'toggleMax',
          }
        },
        touch: {
          vertical: false,
        },
        Toolbar: {
          absolute: true,
          display: {
            right: ["close"],
          },
        },
        Thumbs: false,
        preload: 2,
        PanMode: 'x',
        //gap: 16,
      },
    });

    //modal.flickityInstance = flktyModal;

    const thumbnailSlider = document.querySelector('.thumbnail-slider');

    if (thumbnailSlider) {
        const thumbnailList = document.querySelector('.thumbnail-list');

        const sliderFlktyConfig = {
            ...flktyConfig,
            prevNextButtons: false,
            /*on: {
              ready: function() {
                console.log('Thumbnail slider is ready');
              }
            }*/
        };

        const flktyThumbnails = new Flickity(thumbnailList, sliderFlktyConfig);

        thumbnailSlider.querySelector('.slider-button--prev').addEventListener('click', () => {
            flktyThumbnails.previous();
        });

        thumbnailSlider.querySelector('.slider-button--next').addEventListener('click', () => {
            flktyThumbnails.next();
        });

        const thumbnails = thumbnailList.querySelectorAll('.gallery-cell');

        if(flktyMain) {
            thumbnails.forEach((thumb, index) => {
                thumb.addEventListener('click', () => {
                    flktyMain.select(index);
                });
            });
        }
    }

    //});
});

